module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "tw-h-full tw-flex tw-flex-col"
  }, [(_vm.paieEnable) ? _c('div', {
    staticClass: "tw-grid tw-gap-4 tw-grid-cols-2 home-lg:tw-grid-cols-4 tw-mb-4"
  }, [_c('card-activity-component'), _vm._v(" "), _c('card-news-component'), _vm._v(" "), _c('card-workforce-component'), _vm._v(" "), _c('card-alert-component')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tw-max-h-full home-lg:tw-h-[calc(100%-366px)] home-lg:tw-pb-0 tw-pb-4"
  }, [_c('calendrier-component', {
    attrs: {
      "typeCalendrier": _vm.typeCalendrierAccueil
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13bb54f8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/home.vue.html
// module id = oilu
// module chunks = 2